import { useField } from 'formik';
import {
  Radio,
  FormLabel,
  RadioGroup,
  FormControl,
  FormHelperText,
  RadioGroupProps,
  FormControlLabel,
} from '@mui/material';

import { controlError } from 'utils';

export interface RadioFieldProps extends Omit<
  RadioGroupProps,
  'name' | 'onChange'
> {
  name: string;
  label?: string;
  radioClassName?: string;
  controlErrorLabel?: boolean;
  radioGroupClassName?: string;
  options: { label: string; value: string | number }[];
  onChange?: (
    event: React.ChangeEvent<HTMLInputElement>,
    value: string
  ) => void;
}

export const RadioField = ({
  name,
  label,
  options,
  onChange,
  radioClassName,
  radioGroupClassName,
  ...props
}: RadioFieldProps) => {
  const [field, meta, helpers] = useField(name);

  const errorText = controlError(meta, name, label);
  const hasError = Boolean(errorText);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    helpers.setValue(event.target.value);
    onChange?.(event, event.target.value);
  };

  return (
    <FormControl error={hasError}>
      {label && <FormLabel>{label}</FormLabel>}
      <RadioGroup
        {...props}
        name={field.name}
        onChange={handleChange}
        value={field.value || ''}
        className={radioGroupClassName}
      >
        {options.map((opt) => (
          <FormControlLabel
            key={opt.value}
            value={opt.value}
            className="m-0 items-start"
            label={<p className="pt-0.5">{opt.label}</p>}
            control={<Radio className={radioClassName} />}
          />
        ))}
      </RadioGroup>
      {hasError && <FormHelperText>{errorText}</FormHelperText>}
    </FormControl>
  );
};
